const changeDate = (date) => {
    const dates = document.querySelectorAll('.change-date');

    if (dates.length > 0) {
        dates.forEach((item) => {
        item.innerHTML = date;
        });
    }
}

export default changeDate;